module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "c-menu-mobile u-fixed u-pos-tl u-zindex--3 u-flex u-flex-fd--column u-flex-ai--center u-fit-v",
    class: [_vm.menuMobileIsOpen ? 'is-open' : 'is-close']
  }, [_c('div', {
    staticClass: "c-menu-mobile__overlay u-absolute u-pos-tl u-fit u-bg--black-near u-opacity--70 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-menu-mobile__container u-relative u-zindex--2 u-flex u-flex-jc--center u-fit-w u-bg--white"
  }, [_c('div', {
    staticClass: "u-flex u-flex-fd--column u-flex-ai--end u-w8of10"
  }, [_c('div', [_c('router-link', {
    staticClass: "u-relative t-link u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('contact')
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--black-near u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_contact)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-md"
  }, [_c('router-link', {
    staticClass: "u-relative t-link u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('chef')
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--black-near u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_chef)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-t-md u-flex u-flex-ai--center u-click-area-xxs u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._clickOnRestaurants()
      }
    }
  }, [_c('span', {
    staticClass: "t-text--xxs u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--bold",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_link_restaurants)
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-menu-mobile__close-mobile u-relative u-zindex--2 u-flex u-flex-ai--center u-flex-jc--center u-fit",
    class: [_vm.menuIsOpen || !_vm.menuMobileIsOpen ? 'is-hidden' : 'is-visible'],
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : (!_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-menu-mobile__close js-menu-close u-absolute u-pos-tl u-inline-block",
    class: [_vm.menuIsOpen || !_vm.menuMobileIsOpen ? 'is-hidden' : 'is-visible'],
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-header__link__bars u-marg-l-xxs u-flex u-flex-jc--space-between"
  }, [_c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--left u-fit-h u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--middle u-fit-h u-bg--brand-gold"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-header__link__bars__bar c-header__link__bars__bar--right u-fit-h u-bg--brand-gold"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47188970"}!./src/scripts/components/app-menu-mobile/template.html
// module id = 191
// module chunks = 0